
import { CurrencyApi } from "@/api/CurrencyApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { generateCurrencyOptionLabel } from "@utils/Currency";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";

const InvoiceTemplateFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": "checkbox",
                        "name": "activa",
                        "label": "Activa",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        },
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "title",
                        "label": "Nombre",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 10,
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "currencyId",
                        "label": "Moneda",
                        "isHorizontal": true,
                        "optionsFunction": () => CurrencyApi.optionsList({}, (i) => generateCurrencyOptionLabel(i)),
                        "onChangePubSub": (value: string) => CurrencyIdPubSub.publish({ currencyId: value }),
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "hidden",
                        "isDecimal": true,
                        "name": "exchange_rate"
                    },
                ]
            ]
        }
    ],
};


export default InvoiceTemplateFormConfig;